import {Component, inject, Input, OnInit} from '@angular/core';
import {ProyectoItem} from "../../../../../interfaces/proyecto.interface";
import {TableModule} from "primeng/table";
import {NgIf} from "@angular/common";
import {TramiteService} from "../../../../../tramites/services/tramite.service";
import {TooltipModule} from "primeng/tooltip";

@Component({
    selector: 'app-detalle-construccion-item',
    standalone: true,
    imports: [
        TableModule,
        NgIf,
        TooltipModule
    ],
    templateUrl: './detalle-construccion-item.component.html',
    styleUrl: './detalle-construccion-item.component.scss'
})
export class DetalleConstruccionItemComponent implements OnInit {
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }
    protected ts = inject(TramiteService);
    @Input()
    prj!: ProyectoItem;

    ngOnDestroy(): void {
        console.log(`ngOnDestroy() ->` + this.constructor.name)
    }
}
